import type { PageClickEventData } from '@cash-web/shared-ui-analytics'

export const eventActionType = {
  LINK_CLICK: 'LINK_CLICK',
  OPEN_MODAL: 'OPEN_MODAL',
  BLOCKER_ACTION: 'BLOCKER_ACTION',
}

export const getElementEventData = (
  element: EventTarget & HTMLAnchorElement,
  actionType = eventActionType.LINK_CLICK
): PageClickEventData => {
  return {
    type: element.tagName,
    action: actionType,
    text: element.text,
    target: element.href,
  }
}
